import request from '@/utils/httpRequest'

// 获取类型&设备&能力分组
export function getDeviceGroup (params) {
  return request({
    url: `/device_info/type_device_ability_group`,
    method: 'get',
    params
  })
}
// 查询设备功能状态-详情
export function getAbilityInfo (params) {
  return request({
    url: `/device_info/ability_status`,
    method: 'get',
    params
  })
}

// 新增
export function updateAbilityStatus (data) {
  return request({
    url: `/device_info/update_ability_status`,
    method: 'post',
    data
  })
}
